<template>
  <div>
    <b-message class="no-print" v-if="editing && !newPO && !allItemsValid && itemsInOrder" type="is-primary" has-icon>
        Please fill in all line item fields before marking the quantity received.
    </b-message>
    <b-message class="no-print" v-if="editing && !newPO && itemsInOrder" type="is-primary" has-icon>
        Filling in the quantity received for any item will remove the ability to edit this purchase order.
    </b-message>
    <div class="columns" style="margin: 0px 0px 0px 0px">
      <div class="column column-big" v-if="itemsInOrder"><strong>Description</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Department</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Quantity Ordered</strong></div>
      <div class="column" v-if="itemsInOrder && !newPO"><strong>Quantity Received</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Price</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Price Per</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Total Amount</strong></div>
      <div class="column" v-if="itemsInOrder"><strong>Tracking Number</strong></div>
      <div class="column no-print" v-if="itemsInOrder && editing"><strong> </strong></div>
    </div>
    <!--:allItemsValid="allItemsValid"-->
    <div>
      <purchase-order-lines-row
        v-for="row in data"
        :key="row.recordId"
        :row="row"
        :options="lineItemDescriptionValueList"
        :trackingNumberOptions="trackingNumberOptions"
        :editing="editing"
        :newPO="newPO"
        :receiving="receiving"
        :receivedAll="receivedAll"
        :allItemsValid="allItemsValid"
        ref="poLinesRow"
        @line-rendered="countRenderedLineItems"
        @clicked-remove-line-item="removeLineItem(row)">
        <!--@clicked-receive-line-item="receiveLineItem(row)">-->
      </purchase-order-lines-row>
      <button v-if="editing" class="button is-info is-fullwidth no-print" @click="this.addLineItem" >+ Add Item</button>
    </div>
    <div class="level" style="margin-top: 15px">
      <div class="level-left">
      </div>
      <div class="level-right">
        <strong > Purchase Order Total: </strong>${{ purchaseOrderTotal }}
      </div>
    </div>
  </div>
</template>

<script>
import PurchaseOrderLinesRow from './PurchaseOrderLinesRow';
import { mapState } from 'vuex';
import { mapMutations } from 'vuex';
// import store from '../../store/store.js';

const PRICE = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price';
const QTY = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty';
const PRICE_PER = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer';

export default {

  name: 'PurchaseOrderLines',
  props: ['data', 'editing', 'newPO', 'receiving', 'receivedAll'],
  components:{
    'purchase-order-lines-row': PurchaseOrderLinesRow,
  },
  data () {
    return {
      keepFirst: true,
      selected: null,
      item: '',
      linesRendered: false,
      numberOfLinesRendered: 0,
      trackingNumberOptions: []
    };
  },
  mounted: function(){
    this.createTrackingNumberOptions();
  },
  computed:{
    ...mapState([
      'lineItemDescriptionValueList',
      'trackingNumberValueList'
    ]),
    // Determines the next recordID for an added line item, needed for deleting a line item
    nextRecordId: function(){
      if(this.data.length != 0){
        return Number(this.data[this.data.length - 1].recordId) + 1;
      }
      return 0;
    },

    // Returns truthy value of "Are there items in this purchase order?"
    itemsInOrder: function(){
      if(this.data.length > 0){
        return true;
      }
      else{
        return false;
      }
    },

    // Calculates the grand total of all line item totals
    purchaseOrderTotal: function(){
      var grandTotal = 0;
      this.data.forEach(function(rowItem){
        if(rowItem[PRICE] != null && rowItem[QTY] != null){
          if(rowItem[PRICE_PER] == "Each"){
            grandTotal += Number(rowItem[PRICE] * rowItem[QTY]);
          }
          else{
            grandTotal += Number(rowItem[PRICE] * rowItem[QTY] / 1000)
          }
        }
      });
      return grandTotal.toLocaleString();
    },

    // Determines if all the line items are valid
    allItemsValid: function(){
      if(this.linesRendered == true){
        var isValid = true;
        this.$refs.poLinesRow.forEach(function(row){
          if(row.isValid == false){
            isValid = false;
          }
        });
        return isValid;
      }
      else return false;
    }
  },

  methods:{
    ...mapMutations([
        'updateLineItemDescriptionValueList'
    ]),

    // Adds a new item to the purchase order
    addLineItem: function(event){
      var obj = {
        recordId: this.nextRecordId,
        isValid: false
      };
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::__kptID'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::isReceived'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer'] = "Each"
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qtyReceived'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::trackingNumber'] = ""
      obj['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::zcnPriceExtended'] = ""
      this.data.push(obj);
    },

    countRenderedLineItems: function(){
      this.numberOfLinesRendered++;
      if(this.numberOfLinesRendered == this.data.length){
        this.linesRendered = true;
      }
    },

    // Emits to parent that it needs to remove the chosen line item
    removeLineItem: function(row){
      this.$emit('clicked-remove-line-item', row);
    },

    // Returns the total cost for one line item row
    total: function(qty, price){
      if(qty != null && price != null){
        return qty * price;
      }
      else{
        return 0;
      }
    },

    // Validates that all fields in each line item has been filled in
    validate: function(){
      var isValid = true;
      this.$refs.poLinesRow.forEach(function(row){
        var test = row.validate();
        if(test.valid == false || test.trackingNumberValid == false){
          isValid = test;
        }
      });
      return isValid;
    },

    createTrackingNumberOptions: function(){
      var self = this;
      this.$store.state.trackingNumberValueList.forEach(function(trackingNumber){
        self.trackingNumberOptions.push(trackingNumber['menu__FINANCE_TRACKING_NUMBER__isActive__srt::name']);
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .b-input.disabled{
    background-color: #FFFFFF;
    border-color: #FFFFFF;
    -webkit-box-shadow: none;
    box-shadow: none;
    color: #000000;
  }
.column-big{
    width: 12.5% !important;
  }
   .column{
    width: 12.5% !important;
  }
@media print {

   .column-big{
    width: 25% !important;
    flex-basis: auto;
  }
    .column{
    width: 10.71%;
        font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderLines.vue